module.exports = "/images/Pakistan.png?5eae5a2c39ce67a37fcb39829f70bcde";